import React from "react"
import { Container } from "reactstrap"

const Separator = props => {
  return (
    <section className="separator" {...props}>
      <Container>
        <div className="separator__line" />
      </Container>
    </section>
  )
}

export default Separator
